import React, { Component, PureComponent } from 'react'
import { Icon } from 'semantic-ui-react'
import DataTable from '../datatable'

const columns = [
  {
    name: 'name',
    label: 'Nimi',
    sortable: true,
    id: true,
    render(item) {
      let icon = item.getIn(['data', 'icon'])
      return (
        <span>
          {icon ? <Icon name={icon} /> : null}
          {item.get('name')}
        </span>
      )
    },
  },
  {
    name: 'data.order',
    label: 'Järjestys',
  },
  {
    name: 'data.level',
    label: 'Vaikeustaso',
    options: {
      nonetwork: 'Ei verkostolle',
      1: 'Taso 1',
      2: 'Taso 2',
      3: 'Taso 3',
    },
  },
  {
    name: 'created_at',
    label: 'Luotu',
    date: 'DD.MM.YYYY - HH:mm',
    width: 200,
    sortable: true,
  },
  {
    name: 'id',
    label: 'ID',
    width: 160,
  },
]

export default function TaskTypeRoot() {
  return (
    <DataTable
      id="taskTypes"
      entity="task_type"
      crud
      title="Tehtävätyypit"
      texts={{ createButton: 'Lisää tehtävätyyppi' }}
      columns={columns}
    />
  )
}
